import script from "./CompanyProductListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProductListView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProductListView.vue?vue&type=style&index=0&id=36daf771&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36daf771"]])

export default __exports__